import styled from 'styled-components';
import { MOBILE_BREAKPOINT } from '@/shared/hooks/useBreakpoints';

export const ShowOnMobile = styled.div`
  display: none;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: contents;
  }
`;

export const ShowOnDesktop = styled.div`
  display: contents;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: none;
  }
`;
